import { request } from '@/shared/api/request'

export const getXml = (payload) => {
	return request({ url: 'colcontract/get/xml', method: 'POST', data: payload })
}
